import { render } from "./Header.vue?vue&type=template&id=0d88691a&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=0d88691a&scoped=true&lang=css"

import exportComponent from "/Volumes/jstChillin/Dropbox/pdc2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d88691a"]])

export default __exports__